import appConstants from "../../../../appConstants";

export const isEquipmentMismatch= (trailer, stop) => {
  const { maxFeasibleTrailerLength, minEquipmentSize, fixedEquipmentSize } = stop;
  const { trailerLength } = trailer;
  return (
    (minEquipmentSize && trailerLength < minEquipmentSize) ||
    (maxFeasibleTrailerLength && trailerLength > maxFeasibleTrailerLength) ||
    (fixedEquipmentSize && trailerLength != fixedEquipmentSize)
  );
};

export const isAnchorPointEquipmentMismatch = (trailer, stop) => {
  const { minEquipmentSize } = stop;
  const { trailerLength } = trailer;
  return minEquipmentSize && trailerLength < minEquipmentSize;
};

// Helper function to get default hold pro result
const createDefaultHoldProStatus = () => ({
  isOnHold: false,
  isOnHoldRM: false
});

// Helper function to analyze shipments for hold pro status
const calculateHoldProStatus = (shipments) => {
  if (!shipments?.length) {
    return createDefaultHoldProStatus();
  }
  // Check if any shipment is on hold
  const isOnHold = shipments.some(shipment => shipment.isOnHold);  
  // Check if ALL shipments have both isOnHold true and isOnHoldRM true
  const isOnHoldRM = shipments.every(shipment => 
    shipment.isOnHold && shipment.isOnHoldRM
  );
  return { isOnHold, isOnHoldRM };
};

// Helper function to filter shipments by criteria
const filterShipmentsByProperty = (shipmentsList, filterPredicate) => {
  return shipmentsList.filter(filterPredicate);
};

export const routeHasHoldPro = ({enableHoldPros, shipmentsList, route}) => {
  if (!enableHoldPros || !shipmentsList?.length) {
    return createDefaultHoldProStatus();
  }
  const { routeId } = route;  
  // Filter shipments for this specific route
  const routeShipments = filterShipmentsByProperty(
    shipmentsList,
    (shipment) => shipment.routeId === routeId
  );
  return calculateHoldProStatus(routeShipments);
};

export const stopHasHoldPro = ({enableHoldPros, shipmentsList, stop}) => {
  if (!enableHoldPros || !shipmentsList?.length) {
    return createDefaultHoldProStatus();
  }
  const { routeStopId } = stop;  
  // Filter shipments for this specific stop
  const stopShipments = filterShipmentsByProperty(
    shipmentsList,
    (shipment) => shipment.routeStopId === routeStopId
  );
  return calculateHoldProStatus(stopShipments);
};

export const hasHoldRM = (shipmentData)=> {
  return shipmentData.isOnHold && shipmentData.holdProDetails?.source === appConstants.HOLD_PRO_SOURCE_ROUTEMAX;
};

export const shipmentOnHold = ({enableHoldPros, shipmentData})=> {
  if (!enableHoldPros) {
    return createDefaultHoldProStatus();
  }
  return {
    isOnHold: shipmentData.isOnHold,
    isOnHoldRM: hasHoldRM(shipmentData)
  };
};

export const isCityRoute = (route) => {
  return route.routeName !== appConstants.UNRTD_ROUTENAME && !route.isTrapRoute;
};

export const cityRouteHoldProCount = ({enableHoldPros, routesList, shipmentsList})=> {
 return enableHoldPros &&
  routesList.reduce((acc, route) => {
    return route.isOnHold && isCityRoute(route) 
      ? acc +
          shipmentsList.filter(
            (shipment) => shipment.routeId === route.routeId && shipment.isOnHold
          ).length
      : acc;
  }, 0);
};

export const routeHasMultipleTailLoadStops = (stopsList, routeId) => {
  if (!stopsList) return null;
  const routeStops = stopsList.filter(
    (stop) => stop.routeId?.toLowerCase() === routeId?.toLowerCase()
  );
  const tailLoadCount = routeStops.filter((stop) => stop.isTailLoad).length;
  return tailLoadCount > 1;
};

export const routeHasAssignedDriver = (route) =>
  Boolean(route.driverNumber || route.driverName?.trim());

export const getUniqueDriverCount = (routesList) => {
  const uniqueDrivers = new Set(
    routesList
      .map((route) => route.driverNumber || route.driverName?.trim())
      .filter(Boolean)
  );
  return uniqueDrivers.size;
};

export const routeHasTailLoadStopNotFirstSequence = (stopsList, routeId) => {
  if (!stopsList) return null;
  const routeStops = stopsList.filter(
    (stop) => stop.routeId?.toLowerCase() === routeId?.toLowerCase()
  );
  const hasMisplacedTailLoad = routeStops.some(
    (stop) =>
      stop.isTailLoad &&
      stop.stopSequence !== appConstants.TAIL_LOAD_FIRST_STOP_SEQUENCE
  );
  return hasMisplacedTailLoad;
};